import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CompanyDTO, CompanyListDTO } from '../models/company.model';
import { LinqPredicateDTO } from '../models/linqPredicate.model';
import { LogoDTO } from '../models/logo.model';
import { CompanyAssignLicenceDTO } from '../models/commercialProduct.model';
import { LookupDTO } from '../models/lookup.model';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})

export class CompanyService {

  constructor(private http: HttpClient) {
  }

  getAllCompanies(linqPredicate: Array<LinqPredicateDTO> = null): Promise<Array<CompanyListDTO>> {

    if (linqPredicate == null || linqPredicate == undefined)
      linqPredicate = new Array<LinqPredicateDTO>();

    return this.http.post<Array<CompanyListDTO>>(environment.apiFullUrl + '/Company/GetAll', linqPredicate).toPromise();
  }
  
 getCompanyByID(id: number): Promise<CompanyDTO> {

  return this.http
    .get(environment.apiFullUrl + '/Company/' + id, { responseType: 'text' })
    .toPromise()
    .then((data: string) => {

      const base64 = data.substring(0, data.length - 8);

      const binary = atob(base64);
      const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
      const json = new TextDecoder('utf-8').decode(bytes);

      return JSON.parse(json);
    });
}

getCompanyByIDInternal(id: number): Promise<CompanyDTO> {

  return this.http
    .get(environment.apiFullUrl + '/Company/getCompanyByIDInternal/' + id, { responseType: 'text' })
    .toPromise()
    .then((data: string) => {

      const base64 = data.slice(0, -8); // rimuove gli 8 caratteri random
      const binary = atob(base64);
      const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
      const json = new TextDecoder('utf-8').decode(bytes);

      return JSON.parse(json);
    });

}


  getCompanyListByID(id: number): Promise<CompanyListDTO> {
    return this.http.get<CompanyListDTO>(environment.apiFullUrl + '/Company/GetCompanyListByID/' + id).toPromise();
  }

  saveCompany(company: CompanyDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Company', company).toPromise()
  }

  deleteCompany(id: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/Company/' + id).toPromise();
  }

  storeLogo(dto: LogoDTO) {
    return this.http.post<any>(environment.apiFullUrl + '/Company/StoreLogo', dto).toPromise();
  }

  getSubCompanies(fk_company: number) {
    return this.http.get<any>(environment.apiFullUrl + '/Company/GetSubCompanies/' + fk_company).toPromise();
  }

  getAllCommercialProducts() {
    return this.http.get<any>(environment.apiFullUrl + '/Company/GetAllCommercialProducts').toPromise();
  }

  getCommercialProductsByCompany(fk_company: number) {
    return this.http.get<any>(environment.apiFullUrl + '/Company/GetCommercialProductsByCompany/' + fk_company).toPromise();
  }

  saveAndCreateLicence(companyLicence: CompanyAssignLicenceDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Company/SaveAndCreateLicence', companyLicence).toPromise()
  }

  changeCompanyRelation(fk_subCompany: number, fk_parentCompany: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Company/ChangeCompanyRelation/' + fk_subCompany + '/' + fk_parentCompany).toPromise()
  }

  disableTimeTableCompany(id: number) {
    return this.http.get<CompanyListDTO>(environment.apiFullUrl + '/Company/DisableTimeTableCompany/' + id).toPromise();
  }


  getLookupNation(): Promise<Array<LookupDTO>> {
    return this.http.get<Array<LookupDTO>>(environment.apiFullUrl + '/Company/GetLookupNation' + "?ClientID=E1846FBA-641B-4663-973C-6CED1D778EF9").toPromise()
  }
  getLookupAteco(): Promise<Array<LookupDTO>> {
    return this.http.get<Array<LookupDTO>>(environment.apiFullUrl + '/Company/GetLookupAteco').toPromise()
  }
  RF19GetCompanyInfo(id: number) {
    return this.http.get<any>(environment.apiFullUrl + '/Company/RF19GetCompanyInfo/' +  id).toPromise();
  }
  

}
